import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { ENV } from '@app/env';

import { AppModule } from './app.module';

if (ENV.mode === 'PROD') {
	enableProdMode();
}

platformBrowserDynamic().bootstrapModule(AppModule).then(() => {
	if ('serviceWorker' in navigator && !(window as any).cordova && ENV.mode == 'PROD') {
		navigator.serviceWorker.register('/ngsw-worker.js');
		console.log("-------- SW registered");
	}
}).catch((error) => console.log(error));



// WEBPACK FOOTER //
// ./src/app/main.ts